<div class="w8ben-global-notification-banner">
  <td-wb-notification notificationType="warning"
                      notificationSize="full-width">
    <td-wb-notification-header>
      <td-wb-inline-icon-wrapper>
        <span [innerText]="'tdWb.globalNotificationBanner.w8Ben.HEADER' | tdWbTranslate"></span>
      </td-wb-inline-icon-wrapper>
    </td-wb-notification-header>

    <span [innerText]="'tdWb.globalNotificationBanner.w8Ben.TEXT' | tdWbTranslate"></span>
    <a tdWbHref="modal.w8ben"
       tdWbHrefTaggingEvent="w8ben:home-banner:update">
      <u><span [innerText]="'tdWb.globalNotificationBanner.w8Ben.LINK' | tdWbTranslate"></span></u>
    </a>

    <div translate="tdWb.globalNotificationBanner.w8Ben.NOTE"></div>
  </td-wb-notification>
</div>
